import { Button, Modal } from "react-bootstrap";
import { useRecoilState } from "recoil";
import {
  hasSiteAtom,
  navStepAtom,
  productKeyAtom,
  userInfoAtom,
} from "src/atoms";
import { dateFormatUtc } from "src/utils/dateManagement";
import "./Console.style.scss";
import { IGetCashUserStatusRes } from "src/service/types/pay.type";
import { IGetMyServiceListRes } from "src/service/types/console.type";
import { useProductFlags } from "src/hooks/recoil/useProductFlags";
import { useIsCashApply } from "src/hooks/recoil/useIsCashApply";
import { IGetSiteNxacListRes } from "src/service/types/cloud.type";
import { useRouter } from "src/hooks/useRouter";
import { useTranslation } from "react-i18next";
import CashApply from "src/components/Common/CashApply/CashApply";

interface IConsoleUIProps {
  newSite: () => void;
  serviceList: IGetMyServiceListRes[];
  siteNxacList: IGetSiteNxacListRes[];
  goDetail: any;
  goList: any;
  detailIndex: any;
  viewType: any;
  makeType: any;
  openEcoAdmin: any;
  goEcoAdmin: any;
  openWrapsody: () => void;
  openEco: any;
  promotionNotice: any;
  serviceNotice: any;
  modal: any;
  newServiceName: any;
  toggleModalConfirmServerName: any;
  toggleModalConfirmDelete: any;
  confirmServiceName: any;
  confirmServiceDelete: any;
  handleChange: any;
  makeTrialSite: any;
  makePaySite: any;
  makePromotionSite: any;
  isDone: any;
  showSiteNewModal: any;
  hideModal: any;
  type: any;
  serviceBillUid: any;
  nowTime: any;
  createPercent: any;
  closeCreateMsg: any;
  // msgModalTitle: any;
  // msgModalBody: any;
  // msgModalDesc: any;
  showMsgModal: any;
  // closeButtonMsg: any;
  closeButtonGuide: any;
  showGuideDownloadModal: any;
  handleChangeGuide: any;
  doNotOpenGuide: any;
  goPromiton: any;
  userCashStatus: IGetCashUserStatusRes;
  showCashRequestDel: any;
  showCashReqModal: any;
  hideCashReqModal: any;
  requestCashStatus: any;
  deleteCashReqMsg: any;
  isUnregister: boolean; // 생성 안된 사이트 여부
}
const ConsoleUI = ({
  newSite,
  serviceList,
  siteNxacList,
  goDetail,
  goList,
  detailIndex,
  viewType,
  makeType,
  openEcoAdmin,
  goEcoAdmin,
  openWrapsody,
  openEco,
  promotionNotice,
  serviceNotice,
  modal,
  newServiceName,
  toggleModalConfirmServerName,
  toggleModalConfirmDelete,
  confirmServiceName,
  confirmServiceDelete,
  handleChange,
  makeTrialSite,
  makePaySite,
  makePromotionSite,
  isDone,
  showSiteNewModal,
  hideModal,
  type,
  serviceBillUid,
  nowTime,
  createPercent,
  closeCreateMsg,
  // msgModalTitle,
  // msgModalBody,
  // msgModalDesc,
  showMsgModal,
  // closeButtonMsg,
  closeButtonGuide,
  showGuideDownloadModal,
  handleChangeGuide,
  doNotOpenGuide,
  goPromiton,
  userCashStatus,
  showCashRequestDel,
  showCashReqModal,
  hideCashReqModal,
  requestCashStatus,
  deleteCashReqMsg,
  isUnregister,
}: IConsoleUIProps) => {
  // const productKey = getProductInfo().key;
  const [productKey, setProductKey] = useRecoilState(productKeyAtom);
  const [navStep, setNavStep] = useRecoilState(navStepAtom);
  const [userInfo, setUserInfo] = useRecoilState(userInfoAtom);
  const { isOciProduct, isDspProduct, isFiresideProduct } = useProductFlags();
  const siteMarginTop = "20px";
  const titleFontSize = "16px";
  const titleMarginTop = "20px";
  // const { isCashApply } = useIsCashApply();
  const isCashApply = false;
  const { goSitePromotion, goSiteType } = useRouter();
  const { t } = useTranslation();
  // console.log("userCashStatus", userCashStatus);
  // console.log("isCashApply", isCashApply);
  // console.log("serviceList", serviceList);
  // console.log("isUnregister", isUnregister);
  return !isDone ? (
    <div className="content"></div>
  ) : isCashApply ? (
    <CashApply
      userCashStatus={userCashStatus}
      showCashReqModal={showCashReqModal}
      hideCashReqModal={hideCashReqModal}
      requestCashStatus={requestCashStatus}
      deleteCashReqMsg={deleteCashReqMsg}
      showCashRequestDel={showCashRequestDel}
      handleChange={handleChange}
      isCenter={false}
    />
  ) : serviceList?.length > 0 ? (
    <div
      className={navStep !== 1 && navStep !== 2 ? "content" : "content_noNav"}
    >
      {/* {isLoading ? <Loading /> : ''} */}
      {navStep !== 1 && navStep !== 2 && (
        <h3 className="content__title">
          <p>
            {/*onClick={() => goList()} */}
            {t("siteManagement.title")}
          </p>
        </h3>
      )}
      {promotionNotice !== "" ? (
        <div
          className={`${
            serviceList[detailIndex]?.payStatus === "ENDING"
              ? "warningBox"
              : "noticeBox"
          }`}
        >
          <div>
            {promotionNotice}
            {serviceList[detailIndex]?.payStatus === "ENDING" && (
              <b className="mg ml-10">
                <a className="text text--green" href={`mailto:cloud@fasoo.com`}>
                  &nbsp;
                  {t("siteManagement.paymentHistory.bill.inquiry")}
                </a>
              </b>
            )}
          </div>
        </div>
      ) : (
        ""
      )}
      {makeType === "T_APPLY" ? (
        <div
          className={`${
            serviceList[detailIndex]?.payStatus === "ENDING"
              ? "warningBox"
              : "noticeBox"
          }`}
        >
          <i className="icon_circle_check vertical-middle mg mr-10" />
          <span>
            {t("siteManagement.free.beforeApplication.upgradeInfoMsg")}
          </span>
          <a className="rightButton" onClick={newSite}>
            <span className="text text--blue">
              {t("siteManagement.free.beforeApplication.upgradeBtn")}
            </span>
          </a>
        </div>
      ) : (
        ""
      )}
      {isUnregister ? (
        <div className="flex flex-column align-center">
          <div className="noSite">
            <div className="image" />
          </div>
          <div className="noSite__title">{t("siteManagement.subTitle")}</div>
          <div className="noSite__desc">{t("siteManagement.info")}</div>
          <div className="createButton">
            <button
              type="button"
              onClick={makePaySite}
              className="btn btn-green mg mt-20"
            >
              <i className="icon_plus_white inline-block vertical-middle mg mr-10" />
              {t("siteManagement.createBtn")}
            </button>
          </div>
        </div>
      ) : viewType === "list" ? (
        serviceList !== undefined && serviceList.length > 0 ? (
          <div className="flex flex-wrap">
            {serviceList.map((item: any, index: number) => {
              return (
                <div className="flex-item box">
                  <form className="form " onClick={() => goDetail(index)}>
                    <div className="form-thumnail">
                      {item.serviceName.substring(0, 2)}
                    </div>
                    <div className="form-name">
                      <h4 className="form-name-title">{item.serviceName}</h4>
                      <h4 className="form-name-url">
                        {isOciProduct && productKey === "WRAPSODY"
                          ? "cloud.wrapsody.com"
                          : item.domainName}
                      </h4>
                    </div>
                    <div className="form-info">
                      <i className="icon_user inline-block vertical-middle" />
                      <span className="inline-block vertical-middle mg ml-10">
                        {item.licenseCount}
                      </span>
                      <i className="icon_clock inline-block vertical-middle mg ml-20" />
                      <span className="inline-block vertical-middle mg ml-10">
                        {item.serviceEndTime > 0
                          ? dateFormatUtc(item.serviceEndTime)
                          : t(
                              "siteManagement.paymentHistory.paymentManagement.unlimited"
                            )}
                      </span>
                    </div>
                  </form>
                </div>
              );
            })}
          </div>
        ) : makeType === "T_APPLY" ? (
          <div className="site" style={{ marginTop: siteMarginTop }}>
            <div className="trialApply">
              <div className="image-wait" />
            </div>
            <h3
              className="site__title"
              style={{ marginTop: titleMarginTop, fontSize: titleFontSize }}
            >
              {t("siteType.complete.title")}
            </h3>
            <p className="site__desc">{t("siteType.complete.subTitle")}</p>
          </div>
        ) : makeType === "MAKE_PAY" ? (
          <div className="site" style={{ marginTop: siteMarginTop }}>
            <div className="trialApply">
              <div className="image-wait" />
            </div>
            <h3
              className="site__title"
              style={{ marginTop: titleMarginTop, fontSize: titleFontSize }}
            >
              {t("siteType.paymentSuccess")}
            </h3>
            <p className="site__desc">
              {t("siteManagement.free.afterApplication.subTitle")}
            </p>
            <div className="createButton">
              <button
                type="button"
                onClick={makePaySite}
                className="btn btn-green"
              >
                <i className="icon_plus_white inline-block vertical-middle mg mr-10" />
                {t("siteManagement.createBtn")}
              </button>
            </div>
          </div>
        ) : makeType === "MAKE_PROMOTION" ? (
          <div className="site" style={{ marginTop: siteMarginTop }}>
            <div className="trialApply">
              <div className="image-wait" />
            </div>
            <h3
              className="site__title"
              style={{ marginTop: titleMarginTop, fontSize: titleFontSize }}
            >
              {t("siteManagement.free.afterApplication.title")}
            </h3>
            <p className="site__desc">
              {t("siteManagement.free.afterApplication.subTitle")}
            </p>
            <div className="createButton">
              <button
                type="button"
                onClick={makePromotionSite}
                className="btn btn-green"
              >
                <i className="icon_plus_white inline-block vertical-middle mg mr-10" />
                {t("siteManagement.createBtn")}
              </button>
            </div>
          </div>
        ) : makeType === "C_APPLY" ? (
          <div className="site" style={{ marginTop: siteMarginTop }}>
            <div className="trialApply">
              <div className="image-wait" />
            </div>
            <h3
              className="site__title"
              style={{ marginTop: titleMarginTop, fontSize: titleFontSize }}
            >
              {t("siteType.promotionApply.title")}
            </h3>
            <p className="site__desc">
              {t("siteType.promotionApply.subTitle")}
            </p>
            <div className="applyButton">
              <button
                type="button"
                onClick={goPromiton}
                className="btn btn-green"
              >
                {t("siteType.promotionApply.goToMainBtn")}
              </button>
            </div>
          </div>
        ) : (
          <div className="site" style={{ marginTop: siteMarginTop }}>
            <div className="trialApply">
              <div className="image-done" />
            </div>
            <h3
              className="site__title"
              style={{ marginTop: titleMarginTop, fontSize: titleFontSize }}
            >
              {t("siteManagement.free.afterApplication.title")}
            </h3>
            <p className="site__desc">
              {t("siteManagement.free.afterApplication.subTitle")}
            </p>

            {makeType === "T_APPROVED" ? (
              <div className="createButton">
                <button
                  type="button"
                  onClick={makeTrialSite}
                  className="btn btn-green"
                >
                  <i className="icon_plus_white inline-block vertical-middle mg mr-10" />
                  {t("siteManagement.createBtn")}
                </button>
              </div>
            ) : (
              ""
            )}
          </div>
        )
      ) : viewType === "detail" ? (
        <div>
          {createPercent > 0 && !isOciProduct && (
            <div
              className={`${
                serviceNotice === "SERVICE" ? "installDone" : "installProgress"
              }`}
            >
              <div className="name">
                {serviceNotice === "SERVICE" && (
                  <span className="text text--green">
                    <i className="icon_circle_check vertical-middle mg mr-10 mb-2" />
                    {t("siteManagement.createSite.createStepMsg_1")}
                  </span>
                )}
                <span>
                  {serviceNotice === "CREATE_TENANT"
                    ? t("siteManagement.createSite.createStepMsg_2")
                    : serviceNotice === "REGIST" ||
                      serviceNotice === "INITIALIZING"
                    ? t("siteManagement.createSite.createStepMsg_3")
                    : serviceNotice === "LOADING_CONFIG"
                    ? t("siteManagement.createSite.createStepMsg_4")
                    : serviceNotice === "DB_SETTING" ||
                      serviceNotice === "SETTING_CONFIG"
                    ? t("siteManagement.createSite.createStepMsg_5")
                    : serviceNotice === "CREATE_CERTIFICATION"
                    ? t("siteManagement.createSite.createStepMsg_6")
                    : serviceNotice === "SERVICE_BOOTING" ||
                      serviceNotice === "READY_FOR_DEPLOY_URL"
                    ? t("siteManagement.createSite.createStepMsg_7")
                    : ""}
                </span>
              </div>
              {serviceNotice === "SERVICE" ? (
                <p className="closeBtn" onClick={closeCreateMsg}>
                  {t("common.close")}
                </p>
              ) : (
                <div className="progress progress__chart">
                  <div
                    className="progress-bar"
                    style={{
                      width: `${createPercent}%`,
                    }}
                  ></div>
                </div>
              )}
            </div>
          )}

          {serviceList.length !== 0 && ( // 사이트 관리
            <div className="serviceMng">
              <div className="serviceMng__header flex">
                <div className="serviceMng-thumnail">
                  {serviceList[detailIndex]?.serviceName.substring(0, 2)}
                </div>
                <div className="serviceMng-name">
                  <h4 className="serviceMng-name-title">
                    {serviceList[detailIndex]?.serviceName}
                  </h4>
                  <h4 className="serviceMng-name-url">
                    {isOciProduct && productKey === "WRAPSODY"
                      ? "cloud.wrapsody.com"
                      : serviceList[detailIndex]?.domainName}
                  </h4>
                </div>
                <div className="serviceMng__btn mg ml-auto">
                  <button
                    type="button"
                    className="btn btn-gray"
                    onClick={
                      isOciProduct && productKey === "WRAPSODY"
                        ? openWrapsody
                        : openEco
                    }
                  >
                    {/* 사용자 페이지 */}
                    {t("siteManagement.createSite.goUserPageBtn")}
                  </button>

                  {!isOciProduct && productKey === "WRAPSODY_ECO" && (
                    <button
                      type="button"
                      className="serviceMng-btn btn btn-green mg ml-10"
                      onClick={openEcoAdmin}
                    >
                      {t("siteManagement.createSite.goAdminPageBtn")}
                    </button>
                  )}
                </div>
              </div>

              <div className="serviceDetail">
                <div className="flex justify-space-between align-center">
                  <b
                    className="text text--lg text--blackLt"
                    style={{ marginBottom: "10px", color: "#28292B" }}
                  >
                    {t("siteManagement.createSite.detail.title")}
                  </b>
                  {(serviceList[detailIndex].billType === "PROMOTION" &&
                    parseInt(serviceList[detailIndex].serviceEndTime) !== 0 &&
                    serviceList[detailIndex].serviceEndTime < nowTime) ||
                  (serviceList[detailIndex].billType === "TRIAL" &&
                    serviceNotice === "") ||
                  (serviceList[detailIndex].billType === "PAY" &&
                    !serviceList[detailIndex].nextPayDate) ? (
                    <button
                      type="button"
                      className="btn btn-transparent text text--orange"
                      onClick={toggleModalConfirmDelete}
                    >
                      <i className="icon_trash inline-block vertical-middle" />
                      <span className="inline-block vertical-middle mg ml-2">
                        {t("siteManagement.createSite.delete")}
                      </span>
                    </button>
                  ) : (
                    ""
                  )}
                </div>
                <hr className="mg mt-0" />
                <div className="serviceDetail__item">
                  <div className="serviceDetail__itemKey">
                    {t("siteManagement.createSite.detail.siteName")}
                  </div>
                  <div className="serviceDetail__itemValue">
                    {serviceList[detailIndex].serviceName}
                    {/* 사이트 이름 수정 버튼 (2025.06.10 제거) */}
                    {/* <b
                      className="text text--green cursor-pointer mg ml-10"
                      onClick={toggleModalConfirmServerName}
                    >
                      {t(
                        "siteManagement.createSite.detail.goToEdit"
                      )}
                    </b> */}
                  </div>
                </div>
                <div className="serviceDetail__item">
                  <div className="serviceDetail__itemKey">
                    {t("siteManagement.createSite.detail.siteAddress")}
                  </div>
                  <div className="serviceDetail__itemValue">
                    {isOciProduct && productKey === "WRAPSODY"
                      ? "cloud.wrapsody.com"
                      : serviceList[detailIndex].domainName}
                  </div>
                </div>
                <hr />
                <div className="serviceDetail__item">
                  <div className="serviceDetail__itemKey">
                    {t("siteManagement.createSite.detail.maxUser")}
                  </div>
                  <div className="serviceDetail__itemValue">
                    {serviceList[detailIndex].licenseCount}
                  </div>
                </div>
                {/* 사이트 생성일  */}
                <div className="serviceDetail__item">
                  <div className="serviceDetail__itemKey">
                    {t("siteManagement.createSite.detail.createDate")}
                  </div>
                  <div className="serviceDetail__itemValue">
                    {dateFormatUtc(serviceList[detailIndex]?.serviceEntryTime)}
                  </div>
                </div>
                <hr />
                <div className="serviceDetail__item">
                  <div className="serviceDetail__itemKey">
                    {t("siteManagement.createSite.detail.lastAccessDate")}
                  </div>
                  <div className="serviceDetail__itemValue">
                    {dateFormatUtc(userInfo.loginUnixTime)}
                  </div>
                </div>
                {productKey === "WRAPSODY_ECO" &&
                  serviceList[0]?.priceType === "plus" &&
                  siteNxacList.length > 0 && (
                    <>
                      <hr />
                      <div className="serviceDetail__item">
                        <div className="serviceDetail__itemKey">
                          {t("admin.upc.site.applicationModal")}
                        </div>
                        <div className="serviceDetail__itemValue">
                          <>
                            {siteNxacList.map((nxac, index) => {
                              return (
                                <span>
                                  {nxac.applicationName}
                                  {index !== siteNxacList.length - 1 && ", "}
                                </span>
                              );
                            })}
                          </>
                        </div>
                      </div>
                    </>
                  )}
                {!isOciProduct && (
                  // 서버 위치
                  <div className="serviceDetail__item">
                    <div className="serviceDetail__itemKey">
                      {t("siteManagement.createSite.detail.serverLocation")}
                    </div>
                    <div className="serviceDetail__itemValue">
                      {serviceList[detailIndex].region === "us-east-1"
                        ? t(
                            "siteManagement.createSiteModal.serverLocation.option_2"
                          )
                        : t(
                            "siteManagement.createSiteModal.serverLocation.option_1"
                          )}
                    </div>
                  </div>
                )}
                {!isOciProduct && !isDspProduct && (
                  // 서버 용량
                  <>
                    <hr />
                    <div className="serviceDetail__item">
                      <div className="serviceDetail__itemKey">
                        {t(
                          "siteManagement.createSite.detail.storage.fieldname"
                        )}
                      </div>

                      <div className="serviceDetail__itemValue">
                        <div className="flex">
                          <div className="progress progress__chart mg mb-4">
                            <div
                              className="progress-bar"
                              style={{
                                width:
                                  (parseInt(
                                    serviceList[detailIndex].bucketSizeMB
                                  ) /
                                    1024 /
                                    1024 /
                                    1024 /
                                    (Number(
                                      serviceList[detailIndex].licenseCount
                                    ) *
                                      Number(
                                        serviceList[detailIndex].userPerStorage
                                      ))) *
                                  100 *
                                  3.6,
                              }}
                            ></div>
                          </div>
                          <div className="progress__info mg ml-10">
                            <b>
                              {(
                                parseInt(
                                  serviceList[detailIndex].bucketSizeMB
                                ) /
                                1024 /
                                1024 /
                                1024
                              ).toLocaleString()}
                            </b>
                            {t(
                              "siteManagement.createSite.detail.storage.byteUnit"
                            )}{" "}
                            &nbsp;/&nbsp;
                            {serviceList[detailIndex].userPerStorage === 0 ? (
                              t(
                                "siteManagement.createSite.detail.storage.unlimit"
                              )
                            ) : (
                              <b>
                                {(
                                  Number(
                                    serviceList[detailIndex].licenseCount
                                  ) *
                                  Number(
                                    serviceList[detailIndex].userPerStorage
                                  )
                                ).toLocaleString()}
                              </b>
                            )}
                            {Number(serviceList[detailIndex].userPerStorage) !==
                            0
                              ? t(
                                  "siteManagement.createSite.detail.storage.byteUnit"
                                )
                              : ""}
                            {/* <b> */}
                            {/* {t(
                        'siteManagement.createSite.usageMsg',
                        <NumberFormat
                          value={
                            Number(serviceList[detailIndex].licenseCount) *
                            Number(serviceList[detailIndex].userPerStorage)
                          }
                          displayType={'text'}
                          decimalScale={2}
                          thousandSeparator={true}
                        />,
                        <NumberFormat
                          value={serviceList[detailIndex].bucketSizeMB / 1024}
                          displayType={'text'}
                          decimalScale={2}
                          thousandSeparator={true}
                        />
                      )} */}
                            {/* <NumberFormat
                          value={
                            Number(serviceList[detailIndex].licenseCount) *
                            Number(serviceList[detailIndex].userPerStorage)
                          }
                          displayType={'text'}
                          decimalScale={2}
                          thousandSeparator={true}
                        /> */}
                            {/* </b>
                      GB&nbsp;중&nbsp;
                      <b>
                        <NumberFormat
                          value={serviceList[detailIndex].bucketSizeMB / 1024}
                          displayType={'text'}
                          decimalScale={2}
                          thousandSeparator={true}
                        />
                      </b>
                      GB 사용 */}
                          </div>
                        </div>
                        <p className="text text--gray">
                          {t(
                            `siteManagement.createSite.detail.storage.info${
                              isFiresideProduct ? "_fireside" : ""
                            }`
                          )
                            .split("\n")
                            .map((i: any, index: number) => (
                              <p key={index}>{i}</p>
                            ))}
                        </p>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          )}
        </div>
      ) : (
        ""
      )}
      {modal.confirmServiceNameIsActive && (
        <Modal
          show={modal.confirmServiceNameIsActive}
          onHide={toggleModalConfirmServerName}
          className="modal--sm"
          style={{ opacity: 1 }}
        >
          <Modal.Header closeButton>
            <h4>{t("siteManagement.popup.change.siteName")}</h4>
          </Modal.Header>
          <Modal.Body>
            <input
              id="newServiceName"
              name="newServiceName"
              value={newServiceName}
              type="text"
              placeholder={t("siteManagement.popup.change.enterSiteName")}
              className="form-control"
              onChange={handleChange}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="btn btn-gray"
              onClick={toggleModalConfirmServerName}
            >
              {t("common.cancelBtn")}
            </Button>
            <Button className="btn btn-green" onClick={confirmServiceName}>
              {t("common.okBtn")}
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {modal.confirmDeleteIsActive && (
        <Modal
          show={modal.confirmDeleteIsActive}
          onHide={toggleModalConfirmDelete}
          className="modal--sm"
          style={{ opacity: 1 }}
        >
          <Modal.Header closeButton>
            <h4>{t("siteManagement.popup.delete.title")}</h4>
          </Modal.Header>
          <Modal.Body>
            <p className="text text--14">
              {t("siteManagement.popup.delete.info")}
            </p>
            {t("siteManagement.popup.delete.subInfo")
              .split("\n")
              .map((i: any, index: number) => (
                <p className="text text--gray text--13" key={index}>
                  {i}
                </p>
              ))}
            {/*     <p className="text text--gray text--13">
            {t('siteManagement.popup.delete.subInfo')}
          </p> */}
          </Modal.Body>
          <Modal.Footer>
            <Button className="btn btn-gray" onClick={toggleModalConfirmDelete}>
              {t("common.cancelBtn")}
            </Button>
            <Button className="btn btn-green" onClick={confirmServiceDelete}>
              {t("common.okBtn")}
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  ) : (
    <>
      {isUnregister ? (
        <div className="flex flex-column align-center mg m-auto">
          <div className="noSite">
            <div className="image" />
          </div>
          <div className="noSite__title">{t("siteManagement.subTitle")}</div>
          <div className="noSite__desc">{t("siteManagement.info")}</div>
          <div className="createButton">
            <button
              type="button"
              onClick={makePaySite}
              className="btn btn-green mg mt-20"
            >
              <i className="icon_plus_white inline-block vertical-middle mg mr-10" />
              {t("siteManagement.createBtn")}
            </button>
          </div>
        </div>
      ) : (
        goSiteType()
      )}
    </>
  );
};

export default ConsoleUI;
